<div class="box" role="note" aria-label="System Use Notice">
    <div class="para">
        <h5 class="visually-hidden">System Use Notice</h5>
        <p>
            You are entering the Wisconsin Department of Justice online System.
        </p>
        <p>
            By logging in, you acknowledge that you will comply with all federal laws, state laws and regulations
            related to Criminal Justice Systems. Unauthorized access is prohibited and may be subject to criminal and/or
            civil penalties.
        </p>
        <p>
            System usage may be monitored, recorded and subject to audit. Use of the system indicates consent to
            monitoring and recording of your transactions.
        </p>
    </div>
</div>